import { Component, EventEmitter, HostBinding, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router'; // Import Router for navigation
import { TranslateService } from '@ngx-translate/core';
import { RouterStateTrackerService } from 'src/app/services/router-state-tracker.service';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss'],
  standalone: false,
})
export class AppHeaderComponent implements OnInit, OnDestroy {
  // --- Input Properties ---
  /**
   * Controls whether the header is in 'small' or 'big' mode.
   * Typically used for scroll-based styling.
   */
  @Input() headerSize: boolean = false;

  /**
   * The route path to navigate to when the back button is clicked.
   */
  @Input() backRoute: string = '';

  /**
   * The title displayed in the header.
   */
  @Input() pageTitle: string = '';

  /**
   * The text for the first list view option (e.g., "Unread Messages").
   */
  @Input() innerTitle: string = '';

  /**
   * The text for the second list view option (e.g., "Viewed Messages").
   */
  @Input() innerTitle2: string = '';

  /**
   * The count for the first list view.
   */
  @Input() innerCount: number = 0;

  /**
   * The count for the second list view.
   */
  @Input() innerCount2: number = 0;

  // @Input() activeTitle: boolean;

  // --- Output Properties ---
  /**
   * Emits the selected list type ('unread' or 'read') when a list view option is clicked.
   */
  @Output() activeTitle = new EventEmitter<boolean>();

  // --- Internal State Properties ---
  /**
   * Controls the animation class for the main header.
   */
  headerAnim: string = 'enterTop';

  activeTitleVar: boolean = true; // Default to 'unread'

  smallHeader: string = `smallHeader`;

  bigHeader: string = `bigHeader`;

  constructor(private router: Router, private translate: TranslateService, private routerStateTrackerService: RouterStateTrackerService) {}

  ngOnInit(): void {
    // Initialize isActiveList based on your default preference or initial state
    this.activeTitleVar = true;
  }

  ngOnDestroy(): void {
    // Any cleanup needed when the component is destroyed.
    // For now, nothing specific since RouterStateTrackerService is removed.
  }

  navigateToPage(page: string, data: any = { test: 'from header' }): void {
    const main = this.routerStateTrackerService.combinedData;

    this.routerStateTrackerService.navigateWithPreExitAnimation(page, data);
    // this.router.navigate([page], navigationExtras);
  }

  /**
   * Sets the active list and emits an event.
   * @param listType The type of list selected ('unread' or 'read').
   */
  selectedList(listType: boolean): void {
    this.activeTitleVar = listType;
    this.activeTitle.emit(listType);
  }

  /**
   * Placeholder for a pre-exit animation if you decide to re-implement it.
   * This is a simplified version without the RouterStateTrackerService.
   */
  public async playPreExitAnimation(): Promise<void> {
    this.activeTitleVar = true; // Reset or set to a default for exit
    // this.headerAnim = "exitTop";
    // this.smallHeader = `smallHeader ${this.headerAnim}`;
    // this.bigHeader = `bigHeader ${this.headerAnim}`;
    // Removed animClassBottom and animClassAppear as they weren't directly used in the provided HTML for the header itself.

    // try {
    //   await new Promise(resolve => setTimeout(resolve, 500));
    // } catch (error) {
    //   return Promise.resolve();
    // }
  }
}
